<script lang="ts" setup>
import { useDeviceBreakpoint } from '@d/app/composables/useDeviceBreakpoint'
import '../style/main.scss'

const breakpoint = useDeviceBreakpoint()

const mobile = computed(() => breakpoint.smaller('tablet').value)
</script>

<template>
  <v-layout :class="{ 'is-mobile': mobile }">
    <v-main style="display: flex;flex-direction: column; height: 100%">
      <div style="display: flex; flex-direction: column; flex-grow: 1; overflow: auto">
        <Suspense>
          <slot />
          <template #fallback>
            <v-skeleton-loader type="article" />
          </template>
        </Suspense>
      </div>
    </v-main>
  </v-layout>
</template>
